import { authApi } from '@/utils/axios-config'

const apiBase = 'my/geo';

export default {
    getFavourites() {
        const url = `${apiBase}/favorites`;
        return authApi.get(url);
    },
    getHome() {
        const url = `${apiBase}/favorites/home`;
        return authApi.get(url);
    },
    getWork() {
        const url = `${apiBase}/favorites/work`
        return authApi.get(url);
    },
    getFavouritesLists() {
        const url = `${apiBase}/favorites/lists`;
        return authApi.get(url);
    },
    getSavedRoutes() {
        const url = `${apiBase}/routes`;
        return authApi.get(url);
    },
    
    addFavourite(data) {
        let url = `${apiBase}/favorites`;
        if(data.additionalOption !== '') {
            url += `/${data.additionalOption}`
            data.id = data.additionalOption
            return authApi.put(url, data);
        }
        if(data.listId !== '') {
            url = `${apiBase}/favorites/lists/${data.listId}/favorites`;
        } 
        return authApi.post(url, data);
    },
    addFavouritesList(data) {
        const url = `${apiBase}/favorites/lists`;
        return authApi.post(url, data);
    },
    addSavedRoute(data) {
        const url = `${apiBase}/routes`;
        return authApi.post(url, data);
    },
    addRouteSnapshot(routeId, data) {
        const url = `${apiBase}/routes/${routeId}/snapshot/ROUTENPLANER`;
        return authApi.post(url, data);
    },

    editFavourite(data) {
        if(data.additionalOption !== '') {
            data.id = data.additionalOption
        }
        const url = `${apiBase}/favorites/${data.id}`;
        return authApi.put(url, data);
    },
    editFavouritesList(data) {
        const url = `${apiBase}/favorites/lists/${data.id}`;
        return authApi.put(url, data);
    },
    editSavedRoute(data) {
        const url = `${apiBase}/routes/${data.id}`
        return authApi.put(url, data);
    },
    
    removeFavourite(favouriteId) {
        const url = `${apiBase}/favorites/${favouriteId}`
        return authApi.delete(url)
    },
    removeFavouritesList(listId) {
        const url = `${apiBase}/favorites/lists/${listId}`;
        return authApi.delete(url);
    },
    removeSavedRoute(routeId) {
        const url = `${apiBase}/routes/${routeId}`
        return authApi.delete(url);
    },
}